export default {
  titleQueue: {
    en: 'Not sure how the queue works?',
  },
  titleProduct: {
    en: 'Not sure what product to choose?',
  },
  tutorial1: {
    en: `
    <b>Tutorial 1:</b> Add a product to your queue.
    Click on the “add to queue” button. Add as many
    products as you’d like.
  `,
  },
  tutorial2: {
    en: `
    <b>Tutorial 2:</b> Each cell in the queue
    represents a month. You can move products
    or remove them from the queue.
  `,
  },
  tutorial3: {
    en: `
    <b>Tutorial 3:</b> Check our bestsellers, use our
    smartsearch or a fragrance recommender. We have a
    plenty of options to choose from. Keep your queue
    empty and each month you will recive a fragrance
    of the month.
  `,
  },
  next: {
    en: 'Next',
  },
  exit: {
    en: 'Exit',
  },
  finish: {
    en: 'Finish',
  },
}
